import Dialog from '@zenbusiness/zui/Dialog';
import DialogContentText from '@zenbusiness/zui/DialogContentText';
import Drawer from '@zenbusiness/zui/Drawer';
import { styled } from '@zenbusiness/zui/styles';

const DialogStyle = () => ({
  '& .MuiDialog-container .MuiPaper-root': {
    borderRadius: '20px'
  }
});

const DialogHeaderStyle = () => ({
  height: '60px',
  padding: '8px',
  display: 'flex',
  justifyContent: 'right',
  alignItems: 'center'
});

const DialogContentTextStyle = () => ({
  width: '600px',
  padding: '0 32px 32px 32px'
});

const ContentStyle = () => ({
  padding: '8px 16px 0 16px'
});

const ConfirmModalMobileViewStyle = ({ theme }) => ({
  zIndex: theme.zIndex.modal + 50,
  '& .MuiPaper-root': {
    borderRadius: '16px 16px 0 0',
    padding: '16px 0',
    boxShadow: '0px 4px 16px 2px rgba(46, 46, 46, 0.15)'
  }
});

export const ContentStyled = styled('div')(ContentStyle);
export const DialogStyled = styled(Dialog)(DialogStyle);
export const DialogHeaderStyled = styled('div')(DialogHeaderStyle);
export const DialogContentTextStyled = styled(DialogContentText)(DialogContentTextStyle);
export const ConfirmModalMobileViewStyled = styled(Drawer)(ConfirmModalMobileViewStyle);
